import $ from 'jquery';
import Swiper, { Autoplay, Navigation } from 'swiper';
Swiper.use([Autoplay, Navigation]);

export default class Timeline {
    constructor() {
        if($('.js-timeline').length) {
            const timeline = new Swiper('.js-timeline', {
                grabCursor: true,
                navigation: {
                    nextEl: '.js-timeline__next',
                    prevEl: '.js-timeline__prev',
                },
                slidesPerView: 'auto',
                spaceBetween: 20
            });
        };
    }
}
